import { render, staticRenderFns } from "./FastPhd.vue?vue&type=template&id=318d713e&scoped=true&"
import script from "./FastPhd.vue?vue&type=script&lang=js&"
export * from "./FastPhd.vue?vue&type=script&lang=js&"
import style0 from "./FastPhd.vue?vue&type=style&index=0&id=318d713e&prod&scoped=true&lang=css&"
import style1 from "./FastPhd.vue?vue&type=style&index=1&id=318d713e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d713e",
  null
  
)

export default component.exports